<template>
    <div class="satisfaction-tip">
        <div class="satisfaction-tip__item">
            <p>
                如需在人工会话生效，请确保已开启<a href="/cl/mpSurvey/getConfig">满意度调查</a>
            </p>
            <div class="satisfaction-tip__placeholder satisfaction-tip__placeholder1"></div>
        </div>
        <div class="satisfaction-tip__item">
            <p>
                如需在智能客服会话生效，请前往 <b>智能客服-基础设置-满意度评价</b> 中，开启会话满意度
            </p>
            <div class="satisfaction-tip__placeholder satisfaction-tip__placeholder2"></div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.satisfaction-tip {
    width: 273px;
    p {
        font-size: 13px;
        line-height: 18px;
        color: #1e2330;
    }
    &__item:not(:first-of-type) {
        margin-top: 26px;
    }
    &__item {
        p {
            margin-bottom: 16px;
            max-width: 273px;
        }
        a {
            color: #4A70FF;
        }
    }
    .satisfaction-tip__placeholder {
        width: 273px;
        background-size: 100% 100%;
    }
    .satisfaction-tip__placeholder1 {
        height: 133px;
        background-image: url('../../assets/satisfaction-tip-1.png');
        // background-size: 260px 110px;
    }
    .satisfaction-tip__placeholder2 {
        height: 170px;
        background-image: url('../../assets/satisfaction-tip-2.png');
        margin-bottom: 21px;
        // background-size: 260px 102px;
    }
}
</style>
